<div class="full-height" [@ComponentEnterLeaveAnimation]="true">
  <section class="full-height sidebar-content" fxLayout="column">
    <ng-container *ngIf="isMachineDefined()">
      <header fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" class="sidebar-header" fxHide.lt-sm>
        <mat-icon class="sidebar-header-icon" [svgIcon]="getIconNameForMachineType()"></mat-icon>
        <h3 class="sidebar-header-title" vdw-ellipsis-label [text]="machine.name" matTooltipPosition="above"></h3>
        <button mat-icon-button class="mat-icon-action-button-sm-without-border" (click)="closeMachineDetail()" type="button">
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </header>
      <article #scrollingBlock fxFlex="2 0">
        <app-disabled-form-input fxFlexOrder="1" [label]="'MACHINE.DETAILS.MACHINE_TYPE' | bmsTranslate" [value]="getMachineTypeLabelForTranslate() | bmsTranslate"></app-disabled-form-input>

        <ng-container *ngIf="isMachineOfTypeCarpetLoom()">
          <app-disabled-form-input fxFlexOrder="2" [label]="'TEXTILE_DATA.MACHINE_QUALITY.MACHINE_QUALITY' | bmsTranslate: {count: 1}" [value]="machine.activeQuality?.technicalNameWithVersion">
          </app-disabled-form-input>
          <app-disabled-form-input fxFlexOrder="3" [label]="'TEXTILE_DATA.CREEL.CREEL' | bmsTranslate: {count: 1}" [value]="machine.activeCreel?.name"></app-disabled-form-input>
        </ng-container>

        <ng-container *ngIf="isMachineOfTypeWeavingMachine()">
          <app-disabled-form-input fxFlexOrder="2" [label]="'TEXTILE_DATA.WEAVE_PRODUCT.WEAVE_PRODUCT' | bmsTranslate: {count: 1}" [value]="machine.activeWeaveProduct?.name">
          </app-disabled-form-input>
        </ng-container>

        <ng-container *ngIf="isMachineOfTypeTuftingMachine()">
          <app-disabled-form-input fxFlexOrder="2" [label]="'TEXTILE_DATA.TUFT_PRODUCT.TUFT_PRODUCT' | bmsTranslate: {count: 1}" [value]="machine.activeTuftProduct?.name"> </app-disabled-form-input>
        </ng-container>

        <div fxLayout="column" class="message-groups" *ngIf="hasMessages()">
          <virtual-scroller #virtualScroller [items]="messagesGroups" [parentScroll]="scrollingBlock" (vsEnd)="onVirtualScrollerEndEvent($event)" [enableUnequalChildrenSizes]="true">
            <vdw-message-container *ngFor="let messageGroup of virtualScroller.viewPortItems" [messages]="messageGroup.messages" [showTimestamp]="true"></vdw-message-container>
          </virtual-scroller>
        </div>
      </article>
      <footer class="sidebar-footer" fxFlex="0 0 72px" fxLayout="row" fxLayoutGap="16px" fxLayoutAlign="center center" *ngIf="canShowCreateProductionOrderForMachineButton()">
        <div class="button-skeleton-wrapper standard-btn">
          <button mat-icon-button class="mat-icon-action-button-lg-with-border" [matTooltip]="'MACHINE.ACTIONS.CREATE_PRODUCTION_ORDER' | bmsTranslate" (click)="createProductionOrderForMachine()">
            <mat-icon svgIcon="add-prod-order"></mat-icon>
          </button>
        </div>
      </footer>
    </ng-container>
  </section>
</div>
